export default __webpack_public_path__ + "static/media/FlyingFrog29.ba57a846.png";